import { Component, OnInit } from '@angular/core';

@Component({
  template: `
    <div>
      <div class="help-ask-question card">
        {{ 'help.ask_question_title' | translate }}
        <a href="https://livee.freshdesk.com/support/tickets/new" target="_blank">{{
          'help.ask_question_link' | translate
        }}</a>
      </div>
      <div class="embed-responsive embed-responsive-16by9 iframe-container">
        <iframe
          class="embed-responsive-item"
          src="//doc.livee.com/doc-livee/faq-eva/OnlineFAQ-Eva/Responsive%20HTML5"
        ></iframe>
      </div>
    </div>
  `,
  styles: [
    `
      .help-ask-question {
        font-size: 16px;
        text-align: center;
        padding: 20px 0;
        color: black;
      }
      .iframe-container {
        height: calc(100vh - 122px);
      }
    `
  ]
})
export class HelpComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/modules/help/help.component.ts